module.exports = __webpack_public_path__ + "img/46796.83ad30ce.jpg";